import DelBox from "../comps/DelBox";
import NewSupplier1 from "../models/NewSupplier1";
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import DataTable from "react-data-table-component";

function Suppliers() {
    const [formData, setFormData] = useState({
        l1: [],
        cat_type: 'supplier1',
        search_key: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
    });
    const [isAdmin, setIsAdmin] = useState('');
    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);

    // Invoice modal state (store-purchase invoices)
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [invoiceSummary, setInvoiceSummary] = useState({
        totalInvoices: 0, totalAmount: 0, totalPaid: 0, totalDue: 0,
    });
    const [expandedInvoiceId, setExpandedInvoiceId] = useState(null);

    // Pay modal state
    const [showPayModal, setShowPayModal] = useState(false);
    const [payingInvoice, setPayingInvoice] = useState(null);
    const [paySaving, setPaySaving] = useState(false);
    const [payForm, setPayForm] = useState({
        amount: '',
        payment_mode: 'cash',
        reference: '',
        notes: '',
    });

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        setIsAdmin(roleId === 1 || roleId === "1");

        if (storedData) {
            const fd = new FormData();
            fd.append('type', formData.cat_type + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('page_no', formData.page_no + "");
            fd.append('user_cre_by', "1");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                if (response.data.status) {
                    const records = response.data.records;
                    if (records) {
                        setFormData(prev => ({ ...prev, l1: records }));
                    }
                }
            } catch (error) { }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const delItem = async (editItem) => {
        if (!window.confirm("Are you sure you want to delete this supplier?")) return;
        const fd = new FormData();
        fd.append('user_id', editItem.user_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delUserUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.status) {
                toast.success("Supplier deleted successfully");
                initData();
            }
        } catch (error) {
            toast.error("Failed to delete supplier");
        }
    };

    const handleAddDepart = () => {
        formData.page_no = 0;
        initData();
    };

    // ──────────────────────────────────────────────────────────
    // FETCH STORE-PURCHASE INVOICES for a supplier (action=list)
    // ──────────────────────────────────────────────────────────
    const fetchSupplierInvoices = async (supplier) => {
        setSelectedSupplier(supplier);
        setShowInvoiceModal(true);
        setInvoiceLoading(true);
        setInvoiceList([]);
        setExpandedInvoiceId(null);

        try {
            const fd = new FormData();
            fd.append('action', 'list');
            fd.append('supplier_name', supplier.fname || '');
            fd.append('supplier_id', supplier.user_id || '');

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.supplierStoreInvoiceActionUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.data.status) {
                const records = response.data.records || [];
                const summary = response.data.summary || {};
                setInvoiceList(records);
                setInvoiceSummary({
                    totalInvoices: summary.total_invoices || records.length,
                    totalAmount: parseFloat(summary.total_amount || 0),
                    totalPaid: parseFloat(summary.total_paid || 0),
                    totalDue: parseFloat(summary.total_due || 0),
                });
                if (records.length === 0) toast.info("No invoices found for this supplier");
            } else {
                toast.error(response.data.message || "Failed to fetch invoices");
                setInvoiceList([]);
            }
        } catch (error) {
            console.error("Error fetching supplier invoices:", error);
            toast.error("Error fetching supplier invoices");
            setInvoiceList([]);
        } finally {
            setInvoiceLoading(false);
        }
    };

    // ──────────────────────────────────────────────────────────
    // OPEN PAY POPUP
    // ──────────────────────────────────────────────────────────
    const openPayModal = (invoice) => {
        if (parseFloat(invoice.purchase_due || 0) <= 0) {
            toast.info("This invoice is already fully paid");
            return;
        }
        setPayingInvoice(invoice);
        setPayForm({
            amount: parseFloat(invoice.purchase_due || 0).toFixed(2),
            payment_mode: 'cash',
            reference: '',
            notes: '',
        });
        setShowPayModal(true);
    };

    const handlePayFormChange = (e) => {
        const { name, value } = e.target;
        setPayForm(prev => ({ ...prev, [name]: value }));
    };

    // ──────────────────────────────────────────────────────────
    // SUBMIT PAYMENT (action=pay)
    // ──────────────────────────────────────────────────────────
    const submitPayment = async () => {
        const amount = parseFloat(payForm.amount);
        if (isNaN(amount) || amount <= 0) {
            toast.warning("Enter a valid amount");
            return;
        }
        const dueAmt = parseFloat(payingInvoice?.purchase_due || 0);
        if (amount > dueAmt + 0.01) {
            toast.warning(`Amount cannot exceed due balance (₹${dueAmt.toFixed(2)})`);
            return;
        }
        if (!payForm.payment_mode) {
            toast.warning("Select a payment mode");
            return;
        }

        setPaySaving(true);
        try {
            const fd = new FormData();
            fd.append('action', 'pay');
            fd.append('store_purchase_id', payingInvoice.store_purchase_id);
            fd.append('supplier_id', selectedSupplier?.user_id || '');
            fd.append('supplier_name', selectedSupplier?.fname || '');
            fd.append('amount', amount.toString());
            fd.append('payment_mode', payForm.payment_mode);
            fd.append('reference', payForm.reference || '');
            fd.append('notes', payForm.notes || '');
            fd.append('user_id', ldata?.user_id || '');
            fd.append('user_name', ldata?.fname || ldata?.user_name || '');

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.supplierStoreInvoiceActionUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.data.status) {
                toast.success(response.data.message || "Payment recorded");
                setShowPayModal(false);
                setPayingInvoice(null);
                // Refresh invoice list to pull updated paid/due
                fetchSupplierInvoices(selectedSupplier);
            } else {
                toast.error(response.data.message || "Failed to record payment");
            }
        } catch (error) {
            console.error("Payment error:", error);
            toast.error("Failed to record payment");
        } finally {
            setPaySaving(false);
        }
    };

    // ──────────────────────────────────────────────────────────
    // DELETE A PAYMENT (action=delete_payment) – admin only
    // ──────────────────────────────────────────────────────────
    const deletePayment = async (payment_id) => {
        if (!window.confirm("Delete this payment transaction?")) return;
        try {
            const fd = new FormData();
            fd.append('action', 'delete_payment');
            fd.append('payment_id', payment_id);
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.supplierStoreInvoiceActionUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            if (response.data.status) {
                toast.success("Payment deleted");
                fetchSupplierInvoices(selectedSupplier);
            } else {
                toast.error(response.data.message || "Failed to delete payment");
            }
        } catch (error) {
            toast.error("Failed to delete payment");
        }
    };

    // ──────────────────────────────────────────────────────────
    // PDF EXPORT
    // ──────────────────────────────────────────────────────────
    const exportInvoicesPDF = () => {
        if (invoiceList.length === 0) {
            toast.warning("No invoices to export");
            return;
        }
        try {
            const doc = new jsPDF('l', 'mm', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            doc.setFontSize(16); doc.setFont('helvetica', 'bold');
            doc.text('Supplier Invoice Report', pageWidth / 2, 14, { align: 'center' });

            doc.setFontSize(10); doc.setFont('helvetica', 'normal');
            doc.text(`Supplier: ${selectedSupplier?.fname || '-'}`, 14, 24);
            doc.text(`Contact: ${selectedSupplier?.mobile || '-'}`, 14, 30);
            doc.text(`GSTIN: ${selectedSupplier?.gstin || '-'}`, pageWidth / 2, 24);
            doc.text(`DL No: ${selectedSupplier?.dlno || '-'}`, pageWidth / 2, 30);

            doc.setFontSize(9); doc.setFont('helvetica', 'bold');
            doc.text(`Total Invoices: ${invoiceSummary.totalInvoices}`, 14, 38);
            doc.text(`Total Amount: Rs ${invoiceSummary.totalAmount.toFixed(2)}`, 80, 38);
            doc.setTextColor(0, 128, 0);
            doc.text(`Total Paid: Rs ${invoiceSummary.totalPaid.toFixed(2)}`, 160, 38);
            doc.setTextColor(220, 53, 69);
            doc.text(`Total Due: Rs ${invoiceSummary.totalDue.toFixed(2)}`, 230, 38);
            doc.setTextColor(0, 0, 0); doc.setFont('helvetica', 'normal');

            const today = new Date().toLocaleDateString('en-GB');
            doc.text(`Generated: ${today}`, pageWidth - 14, 38, { align: 'right' });

            const tableHeaders = ['Sl#', 'Invoice No', 'Date', 'Items', 'Total', 'Paid', 'Due', 'Mode', 'Status'];
            const tableBody = invoiceList.map((inv, i) => {
                const total = parseFloat(inv.purchase_total || 0);
                const paid = parseFloat(inv.purchase_paid || 0);
                const due = parseFloat(inv.purchase_due || 0);
                const itemCount = Array.isArray(inv.items) ? inv.items.length : 0;
                return [
                    i + 1,
                    inv.store_purchase_no || inv.store_invoice_number || '-',
                    inv.store_purchase_date || '-',
                    itemCount,
                    `Rs ${total.toFixed(2)}`,
                    `Rs ${paid.toFixed(2)}`,
                    `Rs ${due.toFixed(2)}`,
                    inv.store_purchase_mode || '-',
                    inv.payment_status || 'Unpaid',
                ];
            });

            autoTable(doc, {
                startY: 44,
                head: [tableHeaders],
                body: tableBody,
                theme: 'grid',
                styles: { fontSize: 8, cellPadding: 2, overflow: 'linebreak' },
                headStyles: { fillColor: [64, 81, 137], textColor: 255, fontStyle: 'bold', halign: 'center' },
                columnStyles: {
                    0: { halign: 'center', cellWidth: 12 },
                    3: { halign: 'center', cellWidth: 18 },
                    4: { halign: 'right', cellWidth: 28 },
                    5: { halign: 'right', cellWidth: 28 },
                    6: { halign: 'right', cellWidth: 28 },
                    8: { halign: 'center', cellWidth: 22 },
                },
                didParseCell: (data) => {
                    if (data.column.index === 8 && data.section === 'body') {
                        const status = data.cell.raw;
                        if (status === 'Paid')        { data.cell.styles.textColor = [25, 135, 84]; data.cell.styles.fontStyle = 'bold'; }
                        else if (status === 'Partial') { data.cell.styles.textColor = [255, 193, 7]; data.cell.styles.fontStyle = 'bold'; }
                        else                           { data.cell.styles.textColor = [220, 53, 69]; data.cell.styles.fontStyle = 'bold'; }
                    }
                },
                margin: { top: 44, right: 10, bottom: 20, left: 10 },
                didDrawPage: () => {
                    doc.setFontSize(8); doc.setTextColor(128);
                    doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
                        pageWidth / 2, pageHeight - 10, { align: 'center' });
                },
            });

            const finalY = doc.lastAutoTable.finalY + 10;
            doc.setFontSize(10); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
            doc.text(`Total Amount: Rs ${invoiceSummary.totalAmount.toFixed(2)}`, pageWidth - 14, finalY, { align: 'right' });
            doc.text(`Total Paid: Rs ${invoiceSummary.totalPaid.toFixed(2)}`, pageWidth - 14, finalY + 6, { align: 'right' });
            doc.text(`Total Due: Rs ${invoiceSummary.totalDue.toFixed(2)}`, pageWidth - 14, finalY + 12, { align: 'right' });

            const fileName = `Supplier_Invoices_${(selectedSupplier?.fname || 'unknown').replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;
            doc.save(fileName);
            toast.success("PDF exported successfully!");
        } catch (error) {
            console.error('PDF Export error:', error);
            toast.error("Failed to export PDF");
        }
    };

    const exportInvoicesCSV = () => {
        if (invoiceList.length === 0) {
            toast.warning("No invoices to export");
            return;
        }
        try {
            const headers = ['Sl No', 'Invoice No', 'Date', 'Items', 'Total', 'Paid', 'Due', 'Mode', 'Status'];
            const rows = invoiceList.map((inv, i) => {
                const total = parseFloat(inv.purchase_total || 0);
                const paid = parseFloat(inv.purchase_paid || 0);
                const due = parseFloat(inv.purchase_due || 0);
                const itemCount = Array.isArray(inv.items) ? inv.items.length : 0;
                return [
                    i + 1,
                    `"${(inv.store_purchase_no || inv.store_invoice_number || '-').replace(/"/g, '""')}"`,
                    inv.store_purchase_date || '-',
                    itemCount,
                    total.toFixed(2),
                    paid.toFixed(2),
                    due.toFixed(2),
                    `"${(inv.store_purchase_mode || '-').replace(/"/g, '""')}"`,
                    inv.payment_status || 'Unpaid',
                ];
            });

            const csvContent = [headers.join(','), ...rows.map(r => r.join(','))].join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.setAttribute('href', URL.createObjectURL(blob));
            link.setAttribute('download', `Supplier_Invoices_${(selectedSupplier?.fname || 'unknown').replace(/\s+/g, '_')}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.success("CSV exported successfully!");
        } catch (error) {
            console.error('CSV Export error:', error);
            toast.error("Failed to export CSV");
        }
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            setLdata(JSON.parse(storedData));
            initData();
        }
    }, []);

    // DataTable columns
    const columns = [
        { name: '#', selector: (row, i) => i + 1, sortable: false, width: '60px' },
        { name: 'Name', selector: row => row.fname, sortable: true, grow: 2 },
        { name: 'Contact', selector: row => row.mobile, sortable: true },
        {
            name: 'Address',
            selector: row => `${row.address_line1 || ''}, ${row.address_line2 || ''}, ${row.city || ''}, ${row.pincode || ''}`,
            sortable: true, grow: 2, wrap: true,
        },
        { name: 'GSTIN', selector: row => row.gstin, sortable: true },
        { name: 'DLNO', selector: row => row.dlno, sortable: true },
        {
            name: 'Action',
            cell: (row) => (
                <div className="d-flex gap-1">
                    <button type="button" className="btn btn-sm btn-outline-info"
                        onClick={(e) => { e.preventDefault(); fetchSupplierInvoices(row); }}
                        title="View Invoices">
                        <i className="ri-eye-line"></i>
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-primary"
                        disabled={!isAdmin} style={{ opacity: !isAdmin ? 0.5 : 1 }}
                        onClick={(e) => { e.preventDefault(); setEditItem(row); document.getElementById("addbt453").click(); }}
                        title="Edit">
                        <i className="ri-pencil-fill"></i>
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-danger"
                        disabled={!isAdmin} style={{ opacity: !isAdmin ? 0.5 : 1 }}
                        onClick={(e) => { e.preventDefault(); delItem(row); }}
                        title="Delete">
                        <i className="ri-delete-bin-5-fill"></i>
                    </button>
                </div>
            ),
            ignoreRowClick: true, allowOverflow: true, button: true, width: '150px',
        },
    ];

    const filteredList = formData.search_key.trim() === ""
        ? formData.l1
        : formData.l1.filter(item =>
            (`${item.mobile}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
                `${item.fname}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
                `${item.gstin}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
                `${item.dlno}`.toLowerCase().includes(formData.search_key.toLowerCase()))
        );

    const customStyles = {
        headRow: { style: { backgroundColor: '#f3f6f9', fontWeight: 'bold', fontSize: '14px', borderBottom: '2px solid #405189' } },
        rows: { style: { minHeight: '56px', '&:hover': { backgroundColor: '#f8f9fa', cursor: 'pointer' } } },
        headCells: { style: { paddingLeft: '12px', paddingRight: '12px' } },
        cells: { style: { paddingLeft: '12px', paddingRight: '12px' } },
    };

    const closeInvoiceModal = () => {
        setShowInvoiceModal(false);
        setInvoiceList([]);
        setSelectedSupplier(null);
        setExpandedInvoiceId(null);
    };

    const formatDate = (d) => {
        if (!d) return '-';
        const dt = new Date(d);
        if (isNaN(dt.getTime())) return d;
        return dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const formatDateTime = (d) => {
        if (!d) return '-';
        const dt = new Date(d);
        if (isNaN(dt.getTime())) return d;
        return dt.toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="orderList">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">Suppliers</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <div className="d-flex gap-1 flex-wrap">
                                            <button id="addbt453" style={{ display: "none" }} type="button"
                                                className="btn btn-success add-btn"
                                                data-bs-toggle="modal" data-bs-target="#showModal"></button>
                                            <button type="button" className="btn btn-success add-btn"
                                                onClick={(e) => { e.preventDefault(); setEditItem(null); document.getElementById("addbt453").click(); }}>
                                                <i className="ri-add-line align-bottom me-1"></i> Add Supplier
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="row g-3">
                                    <div className="col-xxl-4 col-sm-6">
                                        <div className="search-box">
                                            <input type="text" className="form-control search"
                                                name="search_key" onChange={handleChange} value={formData.search_key}
                                                placeholder="Search by name, contact, GSTIN, DLNO..." />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body pt-0">
                                <DataTable
                                    columns={columns}
                                    data={filteredList}
                                    pagination
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                                    highlightOnHover striped responsive
                                    customStyles={customStyles}
                                    noDataComponent={
                                        <div className="text-center py-5">
                                            <i className="ri-user-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                            <p className="mt-3 text-muted">No suppliers found</p>
                                        </div>
                                    }
                                />
                                <NewSupplier1 item={editItem} onAddDepart={handleAddDepart} />
                                <DelBox />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ───────── INVOICE MODAL ───────── */}
            {showInvoiceModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block', zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header" style={{ backgroundColor: '#405189', color: '#fff' }}>
                                    <h5 className="modal-title">
                                        <i className="ri-file-list-3-line me-2"></i>
                                        Store Invoices — {selectedSupplier?.fname || 'Supplier'}
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={closeInvoiceModal}></button>
                                </div>

                                <div className="modal-body">
                                    {invoiceLoading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-3 text-muted">Loading invoices...</p>
                                        </div>
                                    ) : invoiceList.length > 0 ? (
                                        <>
                                            {/* Supplier Info */}
                                            <div className="alert alert-light border mb-3">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <strong><i className="ri-user-line me-1"></i> {selectedSupplier?.fname}</strong><br />
                                                        <small className="text-muted">
                                                            <i className="ri-phone-line me-1"></i>{selectedSupplier?.mobile || '-'}
                                                            {selectedSupplier?.address_line1 && (
                                                                <span> | <i className="ri-map-pin-line me-1"></i>{selectedSupplier?.address_line1}, {selectedSupplier?.city}</span>
                                                            )}
                                                        </small>
                                                    </div>
                                                    <div className="col-md-6 text-md-end">
                                                        {selectedSupplier?.gstin && <small className="text-muted d-block">GSTIN: <strong>{selectedSupplier.gstin}</strong></small>}
                                                        {selectedSupplier?.dlno && <small className="text-muted d-block">DL No: <strong>{selectedSupplier.dlno}</strong></small>}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Summary Cards */}
                                            <div className="row mb-3">
                                                <div className="col-md-3">
                                                    <div className="card border-primary mb-0">
                                                        <div className="card-body text-center py-2">
                                                            <small className="text-muted d-block">Total Invoices</small>
                                                            <h4 className="text-primary mb-0">{invoiceSummary.totalInvoices}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card border-warning mb-0">
                                                        <div className="card-body text-center py-2">
                                                            <small className="text-muted d-block">Total Amount</small>
                                                            <h4 className="text-warning mb-0">₹{invoiceSummary.totalAmount.toFixed(2)}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card border-success mb-0">
                                                        <div className="card-body text-center py-2">
                                                            <small className="text-muted d-block">Total Paid</small>
                                                            <h4 className="text-success mb-0">₹{invoiceSummary.totalPaid.toFixed(2)}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card border-danger mb-0">
                                                        <div className="card-body text-center py-2">
                                                            <small className="text-muted d-block">Total Due</small>
                                                            <h4 className="text-danger mb-0">₹{invoiceSummary.totalDue.toFixed(2)}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Invoice Table */}
                                            <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                <table className="table table-bordered table-hover table-sm align-middle mb-0">
                                                    <thead style={{ backgroundColor: '#405189', color: '#fff', position: 'sticky', top: 0, zIndex: 1 }}>
                                                        <tr>
                                                            <th style={{ width: '40px' }}>Sl#</th>
                                                            <th>Invoice No</th>
                                                            <th>Date</th>
                                                            <th className="text-center">Items</th>
                                                            <th className="text-end">Total</th>
                                                            <th className="text-end">Paid</th>
                                                            <th className="text-end">Due</th>
                                                            <th className="text-center">Mode</th>
                                                            <th className="text-center">Status</th>
                                                            <th className="text-center" style={{ width: '160px' }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {invoiceList.map((inv, idx) => {
                                                            const total = parseFloat(inv.purchase_total || 0);
                                                            const paid = parseFloat(inv.purchase_paid || 0);
                                                            const due = parseFloat(inv.purchase_due || 0);
                                                            const itemCount = Array.isArray(inv.items) ? inv.items.length : 0;
                                                            const txnCount = Array.isArray(inv.payments) ? inv.payments.length : 0;

                                                            const status = inv.payment_status || 'Unpaid';
                                                            const statusClass = status === 'Paid' ? 'bg-success'
                                                                : status === 'Partial' ? 'bg-warning text-dark' : 'bg-danger';

                                                            const isExpanded = expandedInvoiceId === inv.store_purchase_id;

                                                            return (
                                                                <>
                                                                    <tr key={inv.store_purchase_id}>
                                                                        <td className="text-center">{idx + 1}</td>
                                                                        <td>
                                                                            <span className="badge bg-secondary-subtle text-secondary">
                                                                                {inv.store_purchase_no || inv.store_invoice_number || '-'}
                                                                            </span>
                                                                        </td>
                                                                        <td>{formatDate(inv.store_purchase_date)}</td>
                                                                        <td className="text-center">
                                                                            <span className="badge bg-info-subtle text-info">{itemCount}</span>
                                                                        </td>
                                                                        <td className="text-end"><strong>₹{total.toFixed(2)}</strong></td>
                                                                        <td className="text-end text-success">₹{paid.toFixed(2)}</td>
                                                                        <td className="text-end text-danger"><strong>₹{due.toFixed(2)}</strong></td>
                                                                        <td className="text-center">{inv.store_purchase_mode || '-'}</td>
                                                                        <td className="text-center">
                                                                            <span className={`badge ${statusClass}`}>{status}</span>
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <div className="d-flex gap-1 justify-content-center">
                                                                                <button type="button"
                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                    title={`Transactions (${txnCount})`}
                                                                                    onClick={() => setExpandedInvoiceId(isExpanded ? null : inv.store_purchase_id)}>
                                                                                    <i className={`ri-${isExpanded ? 'arrow-up' : 'arrow-down'}-s-line`}></i>
                                                                                    <span className="ms-1">{txnCount}</span>
                                                                                </button>
                                                                                <button type="button"
                                                                                    className="btn btn-sm btn-success"
                                                                                    disabled={due <= 0}
                                                                                    onClick={() => openPayModal(inv)}
                                                                                    title={due <= 0 ? 'Fully paid' : 'Pay'}>
                                                                                    <i className="ri-bank-card-line me-1"></i>Pay
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    {isExpanded && (
                                                                        <tr key={`txn-${inv.store_purchase_id}`}>
                                                                            <td colSpan="10" style={{ backgroundColor: '#f8f9fa' }}>
                                                                                <div className="p-2">
                                                                                    <h6 className="mb-2">
                                                                                        <i className="ri-exchange-funds-line me-1"></i>
                                                                                        Payment Transactions
                                                                                    </h6>
                                                                                    {txnCount === 0 ? (
                                                                                        <p className="text-muted mb-0">No payments recorded for this invoice yet.</p>
                                                                                    ) : (
                                                                                        <table className="table table-sm table-bordered mb-0 bg-white">
                                                                                            <thead className="table-light">
                                                                                                <tr>
                                                                                                    <th style={{ width: '40px' }}>#</th>
                                                                                                    <th>Date / Time</th>
                                                                                                    <th className="text-end">Amount</th>
                                                                                                    <th>Mode</th>
                                                                                                    <th>Reference</th>
                                                                                                    <th>Paid By</th>
                                                                                                    <th>Notes</th>
                                                                                                    {isAdmin && <th className="text-center" style={{ width: '60px' }}>Del</th>}
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {inv.payments.map((p, pIdx) => (
                                                                                                    <tr key={p.payment_id}>
                                                                                                        <td>{pIdx + 1}</td>
                                                                                                        <td>{formatDateTime(p.payment_datetime)}</td>
                                                                                                        <td className="text-end text-success">
                                                                                                            <strong>₹{parseFloat(p.payment_amount || 0).toFixed(2)}</strong>
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            <span className="badge bg-primary-subtle text-primary text-uppercase">
                                                                                                                {p.payment_mode || '-'}
                                                                                                            </span>
                                                                                                        </td>
                                                                                                        <td>{p.payment_reference || '-'}</td>
                                                                                                        <td>{p.payment_user_name || '-'}</td>
                                                                                                        <td><small>{p.payment_notes || '-'}</small></td>
                                                                                                        {isAdmin && (
                                                                                                            <td className="text-center">
                                                                                                                <button className="btn btn-sm btn-outline-danger"
                                                                                                                    onClick={() => deletePayment(p.payment_id)}
                                                                                                                    title="Delete payment">
                                                                                                                    <i className="ri-delete-bin-line"></i>
                                                                                                                </button>
                                                                                                            </td>
                                                                                                        )}
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    )}
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                    </tbody>
                                                    <tfoot className="table-light" style={{ position: 'sticky', bottom: 0 }}>
                                                        <tr>
                                                            <th colSpan="4" className="text-end">Totals:</th>
                                                            <th className="text-end">₹{invoiceSummary.totalAmount.toFixed(2)}</th>
                                                            <th className="text-end text-success">₹{invoiceSummary.totalPaid.toFixed(2)}</th>
                                                            <th className="text-end text-danger">₹{invoiceSummary.totalDue.toFixed(2)}</th>
                                                            <th colSpan="3"></th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center py-5">
                                            <i className="ri-file-list-3-line" style={{ fontSize: '48px', color: '#ccc' }}></i>
                                            <p className="mt-3 text-muted">No invoices found for <strong>{selectedSupplier?.fname}</strong></p>
                                        </div>
                                    )}
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeInvoiceModal}>
                                        <i className="ri-close-line me-1"></i> Close
                                    </button>
                                    {invoiceList.length > 0 && (
                                        <>
                                            <button type="button" className="btn btn-success" onClick={exportInvoicesCSV}>
                                                <i className="ri-file-excel-line me-1"></i> Export Excel
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={exportInvoicesPDF}>
                                                <i className="ri-file-pdf-line me-1"></i> Export PDF
                                            </button>
                                        </>
                                    )}
                                    <button type="button" className="btn btn-primary" onClick={() => fetchSupplierInvoices(selectedSupplier)}>
                                        <i className="ri-refresh-line me-1"></i> Refresh
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" style={{ zIndex: 1055 }}></div>
                </>
            )}

            {/* ───────── PAY MODAL ───────── */}
            {showPayModal && payingInvoice && (
                <>
                    <div className="modal fade show" style={{ display: 'block', zIndex: 1080 }} tabIndex="-1">
                        <div className="modal-dialog modal-md modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header" style={{ backgroundColor: '#198754', color: '#fff' }}>
                                    <h5 className="modal-title">
                                        <i className="ri-bank-card-line me-2"></i>
                                        Pay Invoice
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white"
                                        onClick={() => { setShowPayModal(false); setPayingInvoice(null); }}></button>
                                </div>
                                <div className="modal-body">
                                    {/* Invoice summary */}
                                    <div className="alert alert-light border mb-3">
                                        <div className="row small">
                                            <div className="col-6">
                                                <div className="text-muted">Invoice No</div>
                                                <strong>{payingInvoice.store_purchase_no || payingInvoice.store_invoice_number || '-'}</strong>
                                            </div>
                                            <div className="col-6 text-end">
                                                <div className="text-muted">Date</div>
                                                <strong>{formatDate(payingInvoice.store_purchase_date)}</strong>
                                            </div>
                                            <div className="col-4 mt-2">
                                                <div className="text-muted">Total</div>
                                                <strong>₹{parseFloat(payingInvoice.purchase_total || 0).toFixed(2)}</strong>
                                            </div>
                                            <div className="col-4 mt-2 text-center">
                                                <div className="text-muted">Paid</div>
                                                <strong className="text-success">₹{parseFloat(payingInvoice.purchase_paid || 0).toFixed(2)}</strong>
                                            </div>
                                            <div className="col-4 mt-2 text-end">
                                                <div className="text-muted">Due</div>
                                                <strong className="text-danger">₹{parseFloat(payingInvoice.purchase_due || 0).toFixed(2)}</strong>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Paying user */}
                                    <div className="mb-3">
                                        <label className="form-label small text-muted mb-1">Paid By</label>
                                        <div className="form-control bg-light" style={{ cursor: 'not-allowed' }}>
                                            <i className="ri-user-line me-1"></i>
                                            {ldata?.fname || ldata?.user_name || 'Unknown user'}
                                            {ldata?.user_id && <span className="text-muted ms-2 small">(ID: {ldata.user_id})</span>}
                                        </div>
                                    </div>

                                    {/* Amount */}
                                    <div className="mb-3">
                                        <label className="form-label">Amount <span className="text-danger">*</span></label>
                                        <div className="input-group">
                                            <span className="input-group-text">₹</span>
                                            <input type="number" step="0.01" min="0"
                                                className="form-control"
                                                name="amount"
                                                value={payForm.amount}
                                                onChange={handlePayFormChange}
                                                placeholder="0.00" />
                                            <button type="button" className="btn btn-outline-secondary"
                                                onClick={() => setPayForm(prev => ({
                                                    ...prev,
                                                    amount: parseFloat(payingInvoice.purchase_due || 0).toFixed(2)
                                                }))}>
                                                Full Due
                                            </button>
                                        </div>
                                        <small className="text-muted">Max ₹{parseFloat(payingInvoice.purchase_due || 0).toFixed(2)}</small>
                                    </div>

                                    {/* Payment mode */}
                                    <div className="mb-3">
                                        <label className="form-label">Payment Mode <span className="text-danger">*</span></label>
                                        <div className="d-flex gap-2 flex-wrap">
                                            {['cash', 'card', 'online', 'upi', 'cheque'].map(mode => (
                                                <button key={mode} type="button"
                                                    className={`btn btn-sm ${payForm.payment_mode === mode ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => setPayForm(prev => ({ ...prev, payment_mode: mode }))}>
                                                    <i className={`ri-${mode === 'cash' ? 'money-rupee-circle' : mode === 'card' ? 'bank-card' : mode === 'online' ? 'global' : mode === 'upi' ? 'smartphone' : 'file-list-3'}-line me-1`}></i>
                                                    {mode.toUpperCase()}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Reference (txn id / card last-4 / cheque no) */}
                                    {payForm.payment_mode !== 'cash' && (
                                        <div className="mb-3">
                                            <label className="form-label">
                                                {payForm.payment_mode === 'card' && 'Card Number / Last 4 Digits'}
                                                {payForm.payment_mode === 'online' && 'Transaction ID'}
                                                {payForm.payment_mode === 'upi' && 'UPI Transaction ID'}
                                                {payForm.payment_mode === 'cheque' && 'Cheque Number'}
                                            </label>
                                            <input type="text" className="form-control"
                                                name="reference"
                                                value={payForm.reference}
                                                onChange={handlePayFormChange}
                                                placeholder="Reference / transaction id" />
                                        </div>
                                    )}

                                    {/* Notes */}
                                    <div className="mb-3">
                                        <label className="form-label">Notes (optional)</label>
                                        <textarea className="form-control" rows="2"
                                            name="notes"
                                            value={payForm.notes}
                                            onChange={handlePayFormChange}
                                            placeholder="Any remarks..."></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={() => { setShowPayModal(false); setPayingInvoice(null); }}
                                        disabled={paySaving}>
                                        Cancel
                                    </button>
                                    <button type="button" className="btn btn-success"
                                        onClick={submitPayment} disabled={paySaving}>
                                        {paySaving ? (
                                            <><span className="spinner-border spinner-border-sm me-2"></span>Saving...</>
                                        ) : (
                                            <><i className="ri-check-line me-1"></i>Record Payment</>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" style={{ zIndex: 1075 }}></div>
                </>
            )}
        </div>
    );
}

export default Suppliers;